// Maps widget league slugs to canonical display names used across the company's
// analytics (GA4, Looker Studio, cross-team reports).
//
// This file is the single source of truth. /docs/league-display-names.md is a
// human-readable reference that also tracks sports not yet onboarded.
//
// Note: `supercross`, `motocross`, and `supermotocross` all collapse to
// "SuperMotocross (SMX)" by design. The raw slug is still sent as `odds_league`
// so the three disciplines remain distinguishable in GA4.

export const LEAGUE_DISPLAY_NAMES: Record<string, string> = {
  'bkfc': 'Bare Knuckle Fighting Championship (BKFC)',
  'cycling': 'Cycling',
  'f1': 'F1',
  'formula-drift': 'Formula Drift (FD)',
  'gsoc': 'Grand Slam of Curling (GSOC)',
  'hlr': 'High Limit Racing (HLR)',
  'motoamerica': 'MotoAmerica (MA)',
  'motogp': 'MotoGP',
  'nhra': 'National Hot Rod Association (NHRA)',
  'pfl': 'Professional Fighters League (PFL)',
  'supercross': 'SuperMotocross (SMX)',
  'motocross': 'SuperMotocross (SMX)',
  'supermotocross': 'SuperMotocross (SMX)',
  'smx': 'SuperMotocross (SMX)',
  'usac': 'United States Auto Club (USAC)',
  'world-of-outlaws': 'World Of Outlaws (WOO)',
  'wsl': 'World Surf League (WSL)',
}

// Falls back to the raw slug when the mapping has no entry so newly onboarded
// sports never silently drop out of dashboards.
export function toLeagueDisplay(slug: string): string {
  return LEAGUE_DISPLAY_NAMES[slug] ?? slug
}
